<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Select new component</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="newSamplingState" @submit.prevent="saveNewComponent">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <async-autocomplete
                  v-model="trialObjectsSelected"
                  :items="trialData"
                  name="ingredients"
                  label="Select ingredients"
                  item-text="name"
                  item-value="name"
                  return-object
                  multiple
                />
              </v-flex>
              <v-flex sx12>
                <multiple-inputs
                  v-model="customIngredientsSelected"
                  :items="customIngredients"
                  name="customIngredients"
                  label="Add custom ingredients"
                  item-text="name"
                  item-value="name"
                  :returnObject="true"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import asyncAutocomplete from '@/components/form/asyncAutocomplete';
import multipleInputs from "@/components/form/multipleInputs";
import MixingModule from "@/orm/models/MixingModule";
// import SamplingModule from "@/orm/models/SamplingModule";
import Sampling from '@/orm/models/Sampling';
import RecipeModule from "@/orm/models/RecipeModule";
import CustomIngredients from "@/orm/models/CustomIngredients";
import Trial from "@/orm/models/Trial";


export default {
  name: 'newSamplingPopup',
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      trial: [],
      trial_id: this.$route.params.id,
      productionDate: '',
      newSampling: [],
      newSamplingState: {},
      trialObjectsSelected: [],
      customIngredientsSelected: [],
      rawMixesData: [],
      rawPremixesData: [],
      rawRecipesData: [],
      rawRecipesInrgedientsData: [],
      rawProcessData: []
    }
  },
  mounted() {
    this.getMixesPremixes();
    this.getRecipeData();
    this.getProcessData();
    this.getTrial();
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
    trialData() {
      const processIng = Array.isArray(this.prepareProcessIngredients) ? this.prepareProcessIngredients : [];
      const recipesIng = Array.isArray(this.prepareRecipesIngredients) ? this.prepareRecipesIngredients : [];
      const recipes = Array.isArray(this.prepareRecipes) ? this.prepareRecipes : [];
      const mixes = Array.isArray(this.prepareMixes) ? this.prepareMixes : [];
      const preMixes = Array.isArray(this.preparePremixes) ? this.preparePremixes : [];
      const mixesIng = Array.isArray(this.prepareMixesIngredients) ? this.prepareMixesIngredients : [];

      return [...processIng, ...mixes, ...preMixes, ...recipes, ...recipesIng, ...mixesIng]
    },
    prepareMixes() {
      if (!this.rawMixesData.length) {
        return;
      }

      return this.rawMixesData.map((item) => {
        return {...item, name: 'MIX ' + item.name, code: this.trial_id + '-MIX' + item.id, id: item.id + 'MIX', dlc: 2, component_type: 'MIX', production_date: this.productionDate};
      });
    },
    preparePremixes() {
      if (!this.rawPremixesData.length) {
        return;
      }
      return this.rawPremixesData.map((item) => {
        return {...item, name: 'PREMIX ' + item.name, code: this.trial_id + '-PREMIX' + item.id, id: item.id + 'PREMIX', dlc: 2, component_type: 'PREMIX', production_date: this.productionDate};
      });
    },
    prepareMixesIngredients() {
      if (!this.rawMixesData.length) {
        return;
      }

      return JSON.parse(JSON.stringify(this.rawMixesData)).reduce((s1, i) => {
        if (Array.isArray(i.ingredients)) {
          const ings = i.ingredients.map((item)=>{
            item.name = 'MIX ' + i.name + ' INGR ' + item.name;
            item.dlc = 2;
            item.component_type = 'MIXINGR';
            item.production_date = this.productionDate;
            item.code = this.trial_id + '-MIX' + i.id + '-INGR'+ item.id;
            return item
          });
          return [...s1, ...ings]
        } else {
          return s1;
        }
      }, []);
    },
    prepareRecipes() {
      if (!this.rawRecipesData.length) {
        return;
      }
      return JSON.parse(JSON.stringify(this.rawRecipesData)).map((item) => {
        return {...item, name: 'WM ' + item.name + ' ' + item.process.name, code: this.trial_id + '-WM' + item.id, id: item.id + 'WM', dlc: 2, component_type: 'WM', production_date: this.productionDate};
      });
    },
    prepareRecipesIngredients() {
      if (!this.rawRecipesInrgedientsData.length) {
        return;
      }
      return this.rawRecipesInrgedientsData.map((item) => {
        return {...item, name: 'WM INGR ' + item.name, code: this.trial_id + '-WMINGR' + item.id, id: item.id + 'WMINGR', dlc: 2, component_type: 'WMINGR', production_date: this.productionDate};
      });
    },
    customIngredients() {
      return CustomIngredients.all();
    },
    preparedCustomIngredients() {
      return this.customIngredientsSelected.map(ci => {
        if (typeof ci === 'object') return ci;

        const newCustomIng = new CustomIngredients({ name: ci, type: "CUSTOMINGR"}).$toJson();

        return {...newCustomIng, type: "CUSTOMINGR", dlc: 2, component_type: 'CUSTOMINGR', production_date: this.productionDate };
      });
    },
    prepareProcessIngredients() {
      if (!this.rawProcessData.length) {
        return;
      }

      return JSON.parse(JSON.stringify(this.rawProcessData)).reduce((s1, a) => {
        if (Array.isArray(a.stages)) {
          return [...s1, ...a.stages.reduce((s2, b) => {
            if (Array.isArray(b.steps)) {
              return [...s2, ...b.steps.reduce((s3, c) => {
                const rawInlet = Array.isArray(c.inlet) ? c.inlet : [];
                const rawOutlet = Array.isArray(c.outlet) ? c.outlet : [];

                const inlet = rawInlet.map(item => {
                  item.name = a.name + ' ' + b.name + ' ' + c.name + ' ' + item.name;
                  item.dlc = 2;
                  item.component_type = 'PROCESSINGR';
                  item.production_date = this.productionDate;
                  item.code = this.trial_id + '-PR' + a.id + '-STG' + b.id + '-STP' + c.id + '-INGR' + item.id;
                  return item
                });
                const outlet = rawOutlet.map(item => {
                  item.name = a.name + ' ' + b.name + ' ' + c.name + ' ' + item.name;
                  item.dlc = 2;
                  item.component_type = 'PROCESSINGR';
                  item.production_date = this.productionDate;
                  item.code = this.trial_id + '-PR' + a.id + '-STG' + b.id + '-STP' + c.id + '-INGR' + item.id;
                  return item
                });

                  return [...s3, ...inlet, ...outlet]
              }, [])]
            } else {
              return s2;
            }
          }, [])]
        } else {
          return s1;
        }
      }, []);
    },
    selectedProducts() {
      return [...this.trialObjectsSelected, ...this.preparedCustomIngredients]
    },
  },
  methods: {
    close() {
      this.dialogLocal = false;
      this.newSamplingState._reset();
      this.trialObjectsSelected = [];
      this.preparedCustomIngredients = [];
    },
    async saveNewComponent() {
      if (!this.newSamplingState.$valid) {
        return;
      }
      try {

        this.newSampling = await Sampling.create({ data: this.selectedProducts });

        this.$emit('addSampling', this.newSampling);
      } finally {
        this.close();
      }

    },
    async getMixesPremixes() {
      const { params } = this.$route;
      const { mixes, premixes } = await MixingModule.$get({ params });

      this.rawMixesData = mixes.items ? mixes.items : [];
      this.rawPremixesData = premixes.items ? premixes.items : [];
    },
    async getRecipeData() {
      const { params } = this.$route;
      const { recipes } = await RecipeModule.$get({ params });

      this.rawRecipesData = recipes.items ? recipes.items : [];
      this.rawRecipesInrgedientsData = recipes.ingredients ? recipes.ingredients : [];
    },
    async getProcessData() {
      const { params } = this.$route;
      const { processes } = await RecipeModule.$get({ params });

      this.rawProcessData = processes;
    },
    async getTrial() {
      this.trial = JSON.parse(JSON.stringify(Trial.find(this.trial_id)));
      this.productionDate = this.trial.planning_date_rng.to.value;
    }
  },
  components: {
    asyncAutocomplete,
    multipleInputs
  }
}
</script>
